export class CityProxy  {
    public name: string;
    public stateCode: string;
    public stateDescription?: string;
    public synonymous?: string;
}
